

import React, { useRef, useState, useMemo } from "react";
import { Tag, Typography, Input, Button, Tabs, Table, Modal, Checkbox, Upload, Select } from "antd";
import { SearchOutlined, EyeInvisibleOutlined, CloseOutlined, CloudUploadOutlined, InfoCircleOutlined } from "@ant-design/icons";
//import './Reports.scss';
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import AgTableClient from "../../shared/AgTable/AgTableClient";
import './campaign.scss';
import { Segmented } from "antd";
import Cleartrip from "../../assets/images/Cleartrip.jpg";
import sampleCampaignData from "./sampleCampaign.json";



function HotelSalesBoost() {
    const ref = useRef(null);
    const [activeTab, setActiveTab] = useState("my data");
    const [isPromoteModalOpen, setIsPromoteModalOpen] = useState(false);
    const [selectedClients, setSelectedClients] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [isCreateCampaignModalOpen, setIsCreateCampaignModalOpen] = useState(false);
    const [campaignType, setCampaignType] = useState(null);
    const [frequency, setFrequency] = useState(null);
    const [hotel, setHotel] = useState([]);
    const [message1, setMessage1] = useState("");
    const [message2, setMessage2] = useState("");
    const [message3, setMessage3] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);

    const items = [
        {
            key: "1",
            label: "Recon A",
        },
        {
            key: "2",
            label: "Recon B",
        },
    ];

    const cardsData = [
        {
            title: "Active Campaigns",
            value: "3",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.875 7.49993C16.8757 6.34134 16.5836 5.20136 16.0258 4.18589C15.468 3.17041 14.6626 2.31237 13.6844 1.69147C12.7062 1.07057 11.587 0.706936 10.4307 0.634355C9.27438 0.561774 8.11847 0.782595 7.07034 1.27631C6.02221 1.77002 5.11584 2.52062 4.43544 3.45837C3.75503 4.39612 3.32265 5.49062 3.17846 6.64021C3.03426 7.78979 3.18293 8.95717 3.61065 10.0339C4.03837 11.1107 4.73128 12.0619 5.625 12.7992V18.7499C5.62492 18.8565 5.65211 18.9614 5.70397 19.0545C5.75584 19.1476 5.83065 19.2259 5.92131 19.282C6.01197 19.338 6.11546 19.37 6.22195 19.3748C6.32843 19.3795 6.43437 19.357 6.52969 19.3093L10 17.5781L13.4711 19.3132C13.5581 19.3549 13.6535 19.376 13.75 19.3749C13.9158 19.3749 14.0747 19.3091 14.1919 19.1919C14.3092 19.0747 14.375 18.9157 14.375 18.7499V12.7992C15.157 12.1551 15.7867 11.3459 16.2189 10.4297C16.6512 9.51352 16.8752 8.51298 16.875 7.49993ZM4.375 7.49993C4.375 6.38741 4.7049 5.29988 5.32298 4.37485C5.94107 3.44982 6.81957 2.72885 7.84741 2.30311C8.87524 1.87737 10.0062 1.76597 11.0974 1.98301C12.1885 2.20006 13.1908 2.73579 13.9775 3.52246C14.7641 4.30913 15.2999 5.31141 15.5169 6.40255C15.734 7.49369 15.6226 8.62469 15.1968 9.65253C14.7711 10.6804 14.0501 11.5589 13.1251 12.1769C12.2001 12.795 11.1125 13.1249 10 13.1249C8.50867 13.1233 7.07889 12.5301 6.02435 11.4756C4.96982 10.421 4.37666 8.99127 4.375 7.49993ZM5.625 7.49993C5.625 6.63464 5.88159 5.78878 6.36232 5.06931C6.84305 4.34985 7.52633 3.78909 8.32576 3.45796C9.12519 3.12683 10.0049 3.04019 10.8535 3.209C11.7022 3.37781 12.4817 3.79449 13.0936 4.40634C13.7054 5.01819 14.1221 5.79775 14.2909 6.64641C14.4597 7.49508 14.3731 8.37475 14.042 9.17417C13.7108 9.9736 13.1501 10.6569 12.4306 11.1376C11.7112 11.6183 10.8653 11.8749 10 11.8749C8.84006 11.8737 7.72798 11.4124 6.90778 10.5922C6.08758 9.77195 5.62624 8.65987 5.625 7.49993Z" fill="#F0B100" />
                </svg>
            )
        },
        {
            title: "Campaign Response",
            value: "73%",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 2L3 5V9C3 13.55 6.27 17.5 10 18.5C13.73 17.5 17 13.55 17 9V5L10 2Z" fill="#10B981" />
                    <path d="M8.5 11.5L6.5 9.5L5.5 10.5L8.5 13.5L14.5 7.5L13.5 6.5L8.5 11.5Z" fill="white" />
                </svg>
            )
        },
    ];

    const hotelsData = [
        {
            key: '1',
            rank: 1,
            hotelName: 'The Oberoi',
            complianceScore: '93%'
        },
        {
            key: '2',
            rank: 2,
            hotelName: 'The Taj Mahal Palace',
            complianceScore: '92%'
        },
        {
            key: '3',
            rank: 3,
            hotelName: 'The Leela Palace',
            complianceScore: '92%'
        },
        {
            key: '4',
            rank: 4,
            hotelName: 'ITC Maurya',
            complianceScore: '91%'
        },
        {
            key: '5',
            rank: 5,
            hotelName: 'Umaid Bhawan',
            complianceScore: '91%'
        }
    ];

    // Hotel icon mapping - add hotel icons here
    const hotelIcons = {
        'The Oberoi': 'https://static-assets.finkraftai.com/logo/oberoi.png',
        // Add more hotel icons as needed
    };

    const renderHotelName = (text) => {
        const hasIcon = hotelIcons[text];
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {hasIcon ? (
                    <img
                        src={hotelIcons[text]}
                        alt={text}
                        className="hotel-icon"
                        onError={(e) => {
                            // Fallback to generic icon if image fails to load
                            e.target.style.display = 'none';
                            const fallback = e.target.parentElement.querySelector('.name-icon');
                            if (fallback) fallback.style.display = 'block';
                        }}
                    />
                ) : (
                    <div className="name-icon"></div>
                )}
                <span>{text}</span>
            </div>
        );
    };

    const hotelsColumns = [
        {
            title: 'Rank',
            dataIndex: 'rank',
            key: 'rank',
            width: 80,
        },
        {
            title: 'Hotel name',
            dataIndex: 'hotelName',
            key: 'hotelName',
            render: renderHotelName,
        },
        {
            title: 'Compliance Score',
            dataIndex: 'complianceScore',
            key: 'complianceScore',
            align: 'right',
        },
    ];

    const clientsData = [
        {
            key: '1',
            client: 'Deloitte',
            promoted: 'Yes',
            status: 'Active'
        },
        {
            key: '2',
            client: 'KPMG',
            promoted: 'Yes',
            status: 'Active'
        },
        {
            key: '3',
            client: 'PWC',
            promoted: 'No',
            status: 'Pending'
        },
        {
            key: '4',
            client: 'EY',
            promoted: 'No',
            status: 'Pending'
        },
        {
            key: '5',
            client: 'BCG',
            promoted: 'Yes',
            status: 'Active'
        }
    ];

    const renderClientName = (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div className="name-icon"></div>
            <span>{text}</span>
        </div>
    );

    const renderPromoted = (text) => (
        <span style={{ color: text === 'Yes' ? '#10B981' : '#EF4444' }}>
            {text}
        </span>
    );

    const renderStatus = (text) => (
        <Button
            className={`status-badge ${text === 'Active' ? 'status-active' : 'status-pending'}`}
            size="small"
            style={{
                border: 'none',
                borderRadius: '4px',
                height: 'auto',
                padding: '4px 12px',
                fontSize: '13px',
                fontWeight: 500,
                fontFamily: 'Noto Sans',
                cursor: 'default',
                pointerEvents: 'none'
            }}
        >
            {text}
        </Button>
    );

    const clientsColumns = [
        {
            title: 'Client',
            dataIndex: 'client',
            key: 'client',
            render: renderClientName,
        },
        {
            title: 'Promoted',
            dataIndex: 'promoted',
            key: 'promoted',
            render: renderPromoted,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: renderStatus,
        },
    ];

    const clientsList = [
        { id: 1, name: 'Tata Group' },
        { id: 2, name: 'Reliance Industries' },
        { id: 3, name: 'HDFC Bank' },
        { id: 4, name: 'Infosys' },
        { id: 5, name: 'ICICI Bank' },
        { id: 6, name: 'State Bank of India' },
    ];

    // Generate columnDefs from JSON data
    const columnDefs = useMemo(() => {
        if (!sampleCampaignData || sampleCampaignData.length === 0) return [];
        
        const firstRow = sampleCampaignData[0];
        // List of keywords that indicate amount columns
        const amountKeywords = ['cgst', 'igst', 'sgst', 'cess', 'amount', 'value', 'gst', 'total'];
        
        const columns = Object.keys(firstRow).map((key) => {
            // Format header name by replacing underscores and capitalizing
            const headerName = key
                .replace(/_/g, ' ')
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, str => str.toUpperCase())
                .trim();
            
            // Check if this column should have AMOUNT format type
            const isAmountColumn = amountKeywords.some(keyword => 
                key.toLowerCase().includes(keyword.toLowerCase())
            ) && typeof firstRow[key] === 'number';
            
            return {
                field: key,
                headerName: headerName,
                filter: typeof firstRow[key] === 'number' ? 'agNumberColumnFilter' : 'agTextColumnFilter',
                sortable: true,
                resizable: true,
                cellStyle: typeof firstRow[key] === 'number' ? { textAlign: 'right' } : {},
                // Add formatType for amount columns
                ...(isAmountColumn && { formatType: 'AMOUNT' }),
                // Enable row grouping for all columns - allows manual grouping
                enableRowGroup: true,
                // Group by Trade Name by default and hide the original column to avoid duplicates
                rowGroup: key === 'tradeNm',
                hide: key === 'tradeNm',
            };
        });
        
        // Add checkbox selection column at the beginning
        return [
            {
                headerName: '',
                checkboxSelection: true,
                headerCheckboxSelection: true,
                width: 50,
                pinned: 'left',
                lockPosition: true,
                suppressMovable: true,
                sortable: false,
                filter: false,
            },
            ...columns
        ];
    }, []);

    // Use JSON data as rowData
    const rowData = useMemo(() => {
        return sampleCampaignData || [];
    }, []);

    // Extract unique hotel names from selected rows only
    const hotelOptions = useMemo(() => {
        // If no rows are selected, return empty array
        if (!selectedRows || selectedRows.length === 0) return [];
        
        // Get unique hotel names from tradeNm field of selected rows
        const uniqueHotels = new Set();
        selectedRows.forEach(row => {
            // Check if row exists and has tradeNm property
            if (row && row.tradeNm) {
                // Handle different formats: "1.HOTEL1 2.HOTEL2", "HOTEL1, HOTEL2", or single hotel
                let hotelName = row.tradeNm.trim();
                
                // If it contains numbered list (e.g., "1.HOTEL1 2.HOTEL2")
                if (/\d+\./.test(hotelName)) {
                    const hotels = hotelName.split(/\d+\./).map(h => h.trim()).filter(h => h.length > 0);
                    hotels.forEach(hotel => uniqueHotels.add(hotel));
                } 
                // If it contains comma separation
                else if (hotelName.includes(',')) {
                    const hotels = hotelName.split(',').map(h => h.trim()).filter(h => h.length > 0);
                    hotels.forEach(hotel => uniqueHotels.add(hotel));
                }
                // Single hotel name
                else {
                    uniqueHotels.add(hotelName);
                }
            }
        });
        
        // Convert to sorted array of options
        return Array.from(uniqueHotels)
            .sort()
            .map(hotel => ({
                label: hotel,
                value: hotel
            }));
    }, [selectedRows]);

    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <PageHeader
                style={{ height: '60px' }}
                leftActions={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <img src={Cleartrip} style={{ height: '40px', width: "40px" }} alt="Left Action" />
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '4px' }}>
                            <span style={{ color: "#161922", fontSize: '16px' }}>Cleartrip</span>
                            <span style={{ color: "#7D7D82", fontSize: '12px' }}>1245 Grand Avenue, Ojai, CA</span>
                        </div>
                    </div>
                }
            />
            <div className="header-section">
                <div className="header-content">
                    <Typography className="heading-text">Campaigns</Typography>
                    <span className="subheading-text">Manage communication campaigns and service level agreements</span>
                </div>
                <div className="my-segmented" style={{ display: "flex", gap: "8px" }}>
                    <Button
                        disabled={selectedRows.length === 0}
                        style={{
                            color: selectedRows.length > 0 ? 'white' : '#7D7D82',
                            borderColor: selectedRows.length > 0 ? "#0a8394" : '#E1E6EA',
                            backgroundColor: selectedRows.length > 0 ? '#0a8394' : '#F5F5F5',
                            cursor: selectedRows.length > 0 ? 'pointer' : 'not-allowed'
                        }}
                        onClick={() => {
                            if (selectedRows.length > 0) {
                                setIsCreateCampaignModalOpen(true);
                            }
                        }}
                    >
                        Create Campaign
                    </Button>
                </div>

            </div>

            <div className="detail-section">
                {cardsData.map((item, index) => (
                    <div className="detail-card" key={index}>
                        <div className="card-content1">
                            <div className="card-header">
                                <div
                                    className={
                                        index === 0
                                            ? "card-icon"
                                            : index === 1
                                                ? "card-icon1"
                                                : "card-icon2"
                                    }
                                >
                                    {item.icon}
                                </div>
                                <span className="card-title">{item.title}</span>
                            </div>
                            <span className="card-value">{item.value}</span>
                        </div>
                    </div>
                ))}
            </div>
            <div style={{ flex: 1, marginTop: "16px", marginLeft: "20px", marginRight: "20px" }}>
                <AgTableClient
                    columnDefs={columnDefs}
                    rowData={rowData}
                    ref={ref}
                    groupPanel
                    onSelectionChanged={(params) => {
                        const selectedNodes = params.api.getSelectedNodes();
                        const selectedData = [];
                        
                        selectedNodes.forEach(node => {
                            // If it's a group node, get all children data
                            if (node.group) {
                                node.childrenAfterFilter?.forEach(childNode => {
                                    if (childNode.data) {
                                        selectedData.push(childNode.data);
                                    }
                                });
                            } else {
                                // Regular row
                                if (node.data) {
                                    selectedData.push(node.data);
                                }
                            }
                        });
                        
                        setSelectedRows(selectedData);
                    }}
                />
            </div>

            {/* Create Campaign Modal */}
            <Modal
                open={isCreateCampaignModalOpen}
                onCancel={() => {
                    setIsCreateCampaignModalOpen(false);
                    setCampaignType(null);
                    setFrequency(null);
                    setHotel([]);
                    setMessage1("");
                    setMessage2("");
                    setMessage3("");
                }}
                footer={null}
                closeIcon={null}
                width={600}
                className="create-campaign-modal"
                styles={{
                    content: {
                        padding: 0,
                        maxHeight: '90vh',
                        overflow: 'auto'
                    }
                }}
            >
                <div className="create-campaign-modal-content">
                    {/* Modal Header */}
                    <div className="create-campaign-modal-header">
                        <Typography className="create-campaign-modal-title">Create Campaign</Typography>
                        <CloseOutlined 
                            className="create-campaign-modal-close"
                            onClick={() => {
                                setIsCreateCampaignModalOpen(false);
                                setCampaignType(null);
                                setFrequency(null);
                                setHotel([]);
                                setMessage1("");
                                setMessage2("");
                                setMessage3("");
                            }}
                        />
                    </div>

                    {/* Modal Body */}
                    <div className="create-campaign-modal-body">
                        {/* Campaign Type Section */}
                        <div className="create-campaign-section">
                            <Typography className="create-campaign-section-title">Campaign Type</Typography>
                            <Select
                                placeholder="Choose a category"
                                value={campaignType}
                                onChange={setCampaignType}
                                style={{ width: '100%', marginTop: '8px' }}
                                suffixIcon={<span style={{ color: '#7D7D82' }}>▼</span>}
                                options={[
                                    { label: 'Reminder Campaign', value: 'reminder' },
                                    { label: 'Follow-up', value: 'follow-up' },
                                    { label: 'Escalation Request', value: 'escalation' },
                                    { label: 'Approval Request', value: 'approval' },
                                ]}
                            />
                        </div>

                        {/* Frequency Section */}
                        <div className="create-campaign-section" style={{ marginTop: '24px' }}>
                            <Typography className="create-campaign-section-title">Frequency</Typography>
                            <Select
                                placeholder="Select frequency"
                                value={frequency}
                                onChange={(value) => {
                                    setFrequency(value);
                                    // Clear messages when frequency is cleared
                                    if (!value) {
                                        setMessage1("");
                                        setMessage2("");
                                        setMessage3("");
                                    }
                                }}
                                style={{ width: '100%', marginTop: '8px' }}
                                suffixIcon={<span style={{ color: '#7D7D82' }}>▼</span>}
                                options={[
                                    { label: 'Daily', value: 'daily' },
                                    { label: 'Weekly', value: 'weekly' },
                                    { label: 'Monthly', value: 'monthly' },
                                    { label: 'Quarterly', value: 'quarterly' },
                                ]}
                            />
                        </div>

                        {/* Hotel Section */}
                        <div className="create-campaign-section" style={{ marginTop: '24px' }}>
                            <Typography className="create-campaign-section-title">Hotel</Typography>
                            <Select
                                mode="multiple"
                                placeholder="Select hotel(s)"
                                value={hotel}
                                onChange={setHotel}
                                style={{ width: '100%', marginTop: '8px' }}
                                suffixIcon={<span style={{ color: '#7D7D82' }}>▼</span>}
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={hotelOptions}
                                dropdownStyle={{ maxHeight: '200px', overflow: 'auto' }}
                                listHeight={200}
                                virtual={false}
                                maxTagCount="responsive"
                            />
                        </div>

                        {/* Message fields - only show when frequency is selected */}
                        {frequency && (
                            <>
                                {/* Message 1 Section */}
                                <div className="create-campaign-section" style={{ marginTop: '24px' }}>
                                    <Typography className="create-campaign-section-title">Message 1</Typography>
                                    <Input
                                        placeholder="Enter first message"
                                        value={message1}
                                        onChange={(e) => setMessage1(e.target.value)}
                                        style={{ marginTop: '8px' }}
                                    />
                                </div>

                                {/* Message 2 Section */}
                                <div className="create-campaign-section" style={{ marginTop: '24px' }}>
                                    <Typography className="create-campaign-section-title">Message 2</Typography>
                                    <Input
                                        placeholder="Enter second message"
                                        value={message2}
                                        onChange={(e) => setMessage2(e.target.value)}
                                        style={{ marginTop: '8px' }}
                                    />
                                </div>

                                {/* Message 3 Section */}
                                <div className="create-campaign-section" style={{ marginTop: '24px' }}>
                                    <Typography className="create-campaign-section-title">Message 3</Typography>
                                    <Input
                                        placeholder="Enter third message"
                                        value={message3}
                                        onChange={(e) => setMessage3(e.target.value)}
                                        style={{ marginTop: '8px' }}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    {/* Modal Footer */}
                    <div className="create-campaign-modal-footer">
                        <Button
                            onClick={() => {
                                setIsCreateCampaignModalOpen(false);
                                setCampaignType(null);
                                setFrequency(null);
                                setHotel([]);
                                setMessage1("");
                                setMessage2("");
                                setMessage3("");
                            }}
                            style={{
                                borderColor: '#E1E6EA',
                                color: '#161922',
                                backgroundColor: 'white'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                // Handle create campaign logic here
                                console.log('Creating campaign:', { campaignType, frequency, hotel, message1, message2, message3 });
                                setIsCreateCampaignModalOpen(false);
                                setCampaignType(null);
                                setFrequency(null);
                                setHotel([]);
                                setMessage1("");
                                setMessage2("");
                                setMessage3("");
                            }}
                            style={{
                                borderColor: '#0a8394',
                                color: 'white',
                                backgroundColor: '#0a8394'
                            }}
                        >
                            Create Campaign
                        </Button>
                    </div>
                </div>
            </Modal>

        </div>
    );
}

export default HotelSalesBoost;

